/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import RolePermService from '../../services/RolePermService';
import RolePermTypes from '../types/RolePermTypes';

//* get all Roles list items
function getAll(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.GET_ROLEPERM_LIST_REQUEST });
    try {
      const res = await RolePermService.getAll(pageOption, sortData, keyword);
      dispatch({
        type: RolePermTypes.GET_ROLEPERM_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.GET_ROLEPERM_LIST_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

const updateQueryParams = (paging, sorting, keyword) => ({
  type: RolePermTypes.UPDATE_ROLE_QUERY_PARAMS,
  payload: { paging, sorting, keyword }
});

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: RolePermTypes.ADD_ROLEPERM_REQUEST });
    try {
      const res = await RolePermService.add(postData);
      dispatch({ type: RolePermTypes.ADD_ROLEPERM_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().rolePermission.queryParams;
      setTimeout(() => dispatch(RolePermAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.ADD_ROLEPERM_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.GET_ROLEPERM_ITEM_REQUEST });
    try {
      const res = await RolePermService.getItem(code);
      dispatch({
        type: RolePermTypes.GET_ROLEPERM_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.GET_ROLEPERM_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch, getState) => {
    dispatch({ type: RolePermTypes.UPDATE_ROLEPERM_REQUEST });
    try {
      const res = await RolePermService.update(code, postData);
      dispatch({
        type: RolePermTypes.UPDATE_ROLEPERM_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().rolePermission.queryParams;
      setTimeout(() => dispatch(RolePermAction.getAll(paginationData, sortingData, keyword)), 500);
      navigate('/');
      if (submitting) {
        submitting(false);
      }
    } catch (error) {
      if (submitting) {
        submitting(false);
      }
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.UPDATE_ROLEPERM_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: RolePermTypes.DELETE_ROLEPERM_REQUEST });
    try {
      const res = await RolePermService.deleteItem(code);
      dispatch({
        type: RolePermTypes.DELETE_ROLEPERM_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().rolePermission.queryParams;
      setTimeout(() => dispatch(RolePermAction.getAll(paginationData, sortingData, keyword)), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.DELETE_ROLEPERM_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getActiveItem() {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.GET_ROLEPERM_ACTIVE_REQUEST });
    try {
      const res = await RolePermService.getActiveItem();
      dispatch({
        type: RolePermTypes.GET_ROLEPERM_ACTIVE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.GET_ROLEPERM_ACTIVE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getAllPermissions() {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.GET_ALL_PERMISSION_REQUEST });
    try {
      const res = await RolePermService.getAllPermissions();
      dispatch({
        type: RolePermTypes.GET_ALL_PERMISSION_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.GET_ALL_PERMISSION_ERROR,
          error: error.response
        });
      }
    }
  };
}

// function getRoleBasedUser(code) {
//   return async (dispatch) => {
//     dispatch({ type: RolePermTypes.GET_ROLE_BASED_USER_REQUEST });
//     try {
//       const res = await RolePermService.getRoleBasedUser(code);
//       dispatch({
//         type: RolePermTypes.GET_ROLE_BASED_USER_SUCCESS,
//         payload: res.data.data
//       });
//       if (res.data && res.data.message) {
//         toast.success(res.data.message);
//       }
//     } catch (error) {
//       if (error && error.response) {
//         dispatch({
//           type: RolePermTypes.GET_ROLE_BASED_USER_ERROR,
//           error: error.response
//         });
//         if (error.response.data && error.response.data.message) {
//           toast.error(error.response.data.message);
//         }
//       }
//     }
//   };
// }

function assignPermission(code, type, postData) {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.ASSIGN_PERMISSION_REQUEST });
    try {
      const res = await RolePermService.assignPermission(code, type, postData);
      dispatch({
        type: RolePermTypes.ASSIGN_PERMISSION_SUCCESS,
        payload: res.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      // setTimeout(() => dispatch(RolePermAction.getAllPermissions()), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.ASSIGN_PERMISSION_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getPermissions(code, type) {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.GET_PERMISSION_REQUEST });
    try {
      const res = await RolePermService.getPermissions(code, type);
      dispatch({
        type: RolePermTypes.GET_PERMISSION_SUCCESS,
        payload: res.data?.data ?? []
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.GET_PERMISSION_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getUserPermissions() {
  return async (dispatch) => {
    dispatch({ type: RolePermTypes.GET_CURRENT_USER_PERMISSION_REQUEST });
    try {
      const res = await RolePermService.getUserPermissions();
      if (res.status === 200) {
        dispatch({
          type: RolePermTypes.GET_CURRENT_USER_PERMISSION_SUCCESS,
          payload: res.data.data,
          noAccessPayload: false
        });
      } else {
        dispatch({
          type: RolePermTypes.GET_CURRENT_USER_PERMISSION_SUCCESS,
          payload: {},
          noAccessPayload: true
        });
      }
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: RolePermTypes.GET_CURRENT_USER_PERMISSION_ERROR,
          error: error.response
        });
      }
    }
  };
}

const RolePermAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  getAllPermissions,
  // getRoleBasedUser,
  assignPermission,
  getPermissions,
  getUserPermissions,
  updateQueryParams
};

export default RolePermAction;
